import { Title } from "../../../components";
import { Container } from "./styles";

import img from '../../../assets/articulacoes/img1.png'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Protocolo de pós-processamento Sem Contraste</Title>

                    <section className="mt-2 p-3">
                        <p className="text-center">Reformatações:</p>

                        <p>
                        Para os exames de adultos os valores entre 1 a 2 mm de espessura e espaçamento são bem
aceitos na grande maioria dos serviços e para uso pediátrico valores ente 1 a 1,5 mm de
espessura e espaçamento.<br/>
O FOV deve ser o menor possível se adequando a cada paciente sendo os valores entre 12 a
16 cm os mais habituais.<br/>
As reformatações tridimensionais tem grande valor informativo, sendo feitas como rotina em
muitos serviços.
                        </p>
                        

                        <p className="text-center">
                        Reformatação Coluna Cervical sem contraste I.V. (trauma).<br/>
Utilizar o Volume Osso e fazer a seguinte reformatação:
                        </p>

                        <p>
                            <b>Axial Osso filme</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>20 Imagens</b><br/>
                            <b>Averege (Média): </b>
                        </p>
                        <p>
                            <b>Sagital Osso</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>Espaçamento: </b>2mm<br/>
                            <b>Averege (Média): </b>
                        </p>

                        <p>
                            <b>Sagital Osso Filme</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>20 Imagens</b><br/>
                            <b>Averege (Média): </b>
                        </p>

                        <p>
                            <b>Coronal Osso</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>Espaçamento: </b>2mm<br/>
                            <b>Averege (Média): </b>
                        </p>

                        <p>
                            <b>Coronal Osso Filme</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>20 Imagens</b><br/>
                            <b>Averege (Média): </b>
                        </p>

                        <p className="text-center">
                        Utilizar o Volume P.M. (partes moles) e fazer as seguintes reformatações:
                        </p>

                        <p>
                            <b>Axial P.M. filme</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>40 Imagens </b><br/>
                            <b>Averege (Média): </b>
                        </p>
                        <p>
                            <b>Sagital P.M. </b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>Espaçamento: </b>2mm<br/>
                            <b>Averege (Média): </b>
                        </p>

                        <p>
                            <b>Sagital P.M. filme</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>20 Imagens </b><br/>
                            <b>Averege (Média): </b>
                        </p>
                        <p>
                            <b>Coronal P.M. Filme</b><br/>
                            <b>Espessura: </b>2mm<br/>
                            <b>Espaçamento: </b>2mm<br/>
                            <b>Averege (Média): </b>
                        </p>

                        <ul>
                            <li>Fazer 12 imagens em 3D Ósseo Volume Redering da coluna cervical girando da direita para esquerda, salvar como 3D Coluna Cervical Dir. / Esq.</li>
                            <li>Fazer 12 imagens em 3D Ósseo Volume Redering da coluna cervical girando da superior para inferior, salvar como 3D Coluna Cervical Sup. / Inf.</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}